



















import { Vue, Component, Prop } from "vue-property-decorator";
import * as user from "../../_store/user.module";
import { bus } from "../../main";
import AutorizzazioneStudentiPreview from "../PreviewDoc/AutorizzazioneStudentiPreview.vue";
import NominaResponsabileDatiPreview from "../PreviewDoc/NominaResponsabileDatiPreview.vue";
import { DocNominaResponsabileInfo } from "../../_models/docNominaResponsabileInfo";
import { DocAutorizzazioneInfo } from "../../_models/docAutorizzazioneInfo";

@Component({
  components: {
    AutorizzazioneStudentiPreview,
    NominaResponsabileDatiPreview
  }
})
export default class DocPreviewDialog extends Vue {
  // @Prop() docElements!: DocNominaResponsabileInfo;
  private docResponsabileElements: DocNominaResponsabileInfo;
  private docAutorizzazioneElements: DocAutorizzazioneInfo;
  // private elements: DocNominaResponsabileInfo;
  private docPreviewDialog: boolean;

  constructor() {
    super();
    // this.elements = this.docElements
    this.docPreviewDialog = false;
    this.docResponsabileElements = {
      nomeIstituto: "",
      nomeAzienda: "",
      idAzienda: 0,
      idIstituto: 0,
      dataDocumento: "",
      firmaUno: "",
      firmaDue: "",
      idDoc: 0
    };
    this.docAutorizzazioneElements = {
      cognomeAllievo: "",
      nomeAllievo: "",
      luogoNascitaAllievo: "",
      dataNascitaAllievo: "",
      indirizzoAllievo: "",
      comuneAllievo: "",
      provinciaAllievo: "",
      capAllievo: "",
      telefonoAllievo: "",
      emailAllievo: "",
      classeAllievo: "",
      cognomeTutore: "",
      nomeTutore: "",
      relazioneParentale: "",
      telefonoTutore: "",
      indirizzoTutore: "",
      comuneTutore: "",
      provinciaTutore: "",
      capTutore: "",
      firmaAllievo: "",
      firmaTutore: "",
      statoAutorizzazione: 0,
      idDoc: 0,
      dataDocumento: "",
      codiceFiscaleAllievo: "",
      statoNascitaAllievo: ""
    };
  }
  //   save() {
  //     if (this.docElements.idDoc === 0) {
  //       user
  //         .dispatchResponsabileDatiDoc(this["$store"], this.docElements)
  //         .then(() => {
  //           bus.$emit("successfullOperation", "Documento inviato con successo");
  //           this["$router"].push("/moduli");
  //         })
  //         .catch(error => {
  //           bus.$emit("errorOperation", error.response.data.message);
  //         });
  //     } else {
  //       user
  //         .dispatchUpdateResponsabileDatiDoc(
  //           this["$store"],
  //           this.docElements.idDoc
  //         )
  //         .then(() => {
  //           bus.$emit("successfullOperation", "Documento inviato con successo");
  //           this["$router"].push("/moduli");
  //         });
  //     }
  //   }

  created() {
    //@ts-ignore
    bus.$on("openDocResponsabilePreview", payload => {
      this.docResponsabileElements = payload;
      this.docPreviewDialog = true;
    });

    //@ts-ignore
    bus.$on("openDocAutorizzazionePreview", payload => {
      this.docAutorizzazioneElements = payload;
      this.docPreviewDialog = true;
    });

    bus.$on("closeDocPreviewDialog", () => {
      this.docPreviewDialog = false;
    });
  }
}
